import(/* webpackMode: "eager" */ "/vercel/path0/src/app/student-program/student-program.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["HubSpotForm"] */ "/vercel/path0/src/components/forms/HubSpotForm/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CarouselIndicator"] */ "/vercel/path0/src/components/ui/CarouselIndicator/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Cursor","GlobalCursor"] */ "/vercel/path0/src/components/ui/Cursor/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ui/ExoLink/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/vercel/path0/src/components/ui/Header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Outro"] */ "/vercel/path0/src/components/ui/Outro/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Preloader"] */ "/vercel/path0/src/components/ui/Preloader/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SecondaryHeader"] */ "/vercel/path0/src/components/ui/SecondaryHeader/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DarkSection"] */ "/vercel/path0/src/components/ui/Section/DarkSection/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Video"] */ "/vercel/path0/src/components/ui/Video/index.tsx");
